import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import Inputmask from 'inputmask'
import toastr from 'toastr'
import Progress from '../Progress'
import PhoneField from '../PhoneField'

function Step2({ validateField }) {
    setTimeout(() => {
        const arr = document.querySelectorAll('[data-inputmask]');
        Inputmask({ 'placeholder': '' }).mask(arr);
    }, 500);
    const authContext = useContext(AuthContext);
    let { lead, gotoNextStep, step } = authContext;

    const initialState = {
        first_name: lead && lead.owners.length ? lead.owners[0].first_name : null,
        last_name: lead && lead.owners.length ? lead.owners[0].last_name : null,
        email: lead ? lead.business_email : null,
        phone: lead && lead.owners.length ? lead.owners[0].phone : null,
        phone_extension: lead && lead.owners.length ? lead.owners[0].phone_extension : '+1',
        business_dba: lead && lead.business_dba ? lead.business_dba : null,
        business_monthly_volume: lead && lead.business_monthly_volume,
        page_id: process.env.REACT_APP_PAGE_ID,
        captchaVerified: true,
        has_salesAgent: false,
        salesAgent: null,


    }

    const [fields, setFields] = useState(initialState);
    const handleChange = (event) => {
        const target = event.target;
        let value = target.value;
        let index = target.name;
        validateField(target);
        setFields({
            ...fields, [index]: value
        });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const $array = Object.keys(fields);
        const $errorbag = [];
        $array.map((item) => {
            const target = document.getElementsByName(item)[0];
            if (target) {
                let $result = validateField(target);
                if ($result) {
                    $errorbag.push($result);
                }
            }
            return null;
        });
        if ($errorbag.length === 0) {
            gotoNextStep(fields, step);
        } else {
            let $format = '';
            $errorbag.map((error, i) => {
                const $err = error + '<br/>';
                $format += $err;
                return null;
            })
            toastr.error($format);
        }
    }

    return (
        <>
            <Progress step={step} />

            <form onSubmit={e => handleSubmit(e)}>

                <div className="container">
                    <div className="row">
                        <div className="form-group col-md-6">
                            <label htmlFor="first_name">First Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-user-tag"></i></span>
                                <input type="text" name="first_name"
                                    className="form-control" onChange={e => handleChange(e)}  value={fields.first_name || ''} />
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="last_name">Last Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-user-tag"></i></span>
                                <input type="text" name="last_name" onChange={e => handleChange(e)}
                                    className="form-control"  value={fields.last_name || ''} />
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="business_dba">Business Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-user-tag"></i></span>
                                <input type="text" name="business_dba" onChange={e => handleChange(e)}
                                    className="form-control"  value={fields.business_dba || ''} />
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="phone">Phone Number</label>

                            <PhoneField handleChange={handleChange} phone={{ name: 'phone', value: fields.phone }} extension={{ value: fields.phone_extension, name: 'phone_extension' }} />


                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="email">Business Email</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-envelope-open"></i></span>
                                <input type="text" name="email" placeholder="example@email.com" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.email || ''} />
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="business_monthly_volume">Monthly Visa/MC/Discover/Amex volume </label>
                            <div className="input-group">
                                <span className="input-group-prepend"><span className="input-group-text"><i className="fab fa-cc-discover"></i></span></span>
                                <select className="custom-select" defaultValue={fields.business_monthly_volume || ''} onChange={e => handleChange(e)}
                                    name="business_monthly_volume">
                                    <option value="" disabled>Select...</option>
                                    <option value="$0-$5000">$0-$5000</option>
                                    <option value="$5,000-$10,000">$5,000-$10,000</option>
                                    <option value="$10,000-$20,000">$10,000-$20,000</option>
                                    <option value="$20,000-$30,000">$20,000-$30,000</option>
                                    <option value="$30,000-$50,000">$30,000-$50,000</option>
                                    <option value="$50,000-$75,000">$50,000-$75,000</option>
                                    <option value="$75,000-$100,000">$75,000-$100,000</option>
                                    <option value="$100,000+">$100,000+</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <SubmitForm />
                </div>


            </form>
        </>
    )
}

export default Step2
